import React, { useMemo } from "react";
import { Card, GridLegacy } from "@mui/material";
import { convertObjectToSelectOptions } from "../../../../templateHelpers";
import TranslationWrapper from "../../../../components/TranslationWrapper/TranslationWrapper.tsx";
import CardBody from "../../../../components/Card/CardBody";
import FormSwitchTC from "../../../../components/Forms/FormSwitchTC";
import FormSelectTC from "../../../../components/Forms/FormSelectTC";
import FormTextTC from "../../../../components/Forms/FormTextTC";
import FormControlledInputTC from "../../../../components/Forms/FormControlledInputTC";
import { useFormContext, useWatch } from "react-hook-form";
import Button from "../../../../components/CustomButtons/Button";
import { _get } from "../../../../http";

function BlackBox() {
  const apiMethod = useMemo(
    () => [
      { value: "IP", label: "Rest API via IP" },
      // { value: "WS", label: "Rest API via websockets" },
    ],
    []
  );
  const { vestigingId, reloadDataFromServer } = useFormContext();
  const bbCountries = useMemo(() => [{ value: "be", label: "Belgium" }], []);
  const apiMethodOptions = useMemo(() => convertObjectToSelectOptions(apiMethod), []);
  const bbCountriesOptions = useMemo(() => convertObjectToSelectOptions(bbCountries), []);
  const blackBoxKeyFileValue = useWatch({ name: "apiaccounts__blackBoxKeyFile" });
  const blackBoxKeyPassphraseValue = useWatch({ name: "apiaccounts__blackBoxKeyFile" });

  const setupFDMAuth = () => {
    const url = "core/vestigingen/" + vestigingId + "/getFdmKey";
    _get(url).then((result) => {
      reloadDataFromServer();
    });
  };

  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
          <GridLegacy container spacing={1} style={{ maxWidth: 1400 }}>
            <GridLegacy item xs={12}>
              <h3>
                <TranslationWrapper
                  tDefault={"Blackbox (GKS/SCE Belgium Cashdesk Registration)"}
                  tKey={"vestigingen.form.mail.headers.blackbox"}
                />
              </h3>
            </GridLegacy>
            <FormSwitchTC
              name={"useBlackbox"}
              tDefault={"Use blackbox"}
              tKey={"vestigingen.form.apiaccounts.label.useBlackbox"}
            />
            <FormSelectTC
              name={"apiaccounts__blackBoxMode"}
              options={apiMethodOptions}
              tDefault={"Operation mode"}
              tKey={"vestigingen.form.apiaccounts.label.blackBoxMode"}
            />
            <FormSelectTC
              name={"apiaccounts__blackBoxCountry"}
              options={bbCountriesOptions}
              tDefault={"Country"}
              tKey={"vestigingen.form.apiaccounts.label.blackBoxCountry"}
            />
            <FormTextTC
              name={"apiaccounts__blackBoxPosSerial"}
              tDefault={"POS Serial"}
              tKey={"vestigingen.form.apiaccounts.label.blackBoxPosSerial"}
            />
            <FormTextTC
              name={"apiaccounts__blackBoxIP"}
              tDefault={"Endpoint IP"}
              tKey={"vestigingen.form.apiaccounts.label.blackBoxIP"}
            />
            <FormTextTC
              name={"apiaccounts__blackBoxPort"}
              tDefault={"Endpoint port"}
              tKey={"vestigingen.form.apiaccounts.label.blackBoxPort"}
            />
            <FormTextTC
              name={"apiaccounts__blackBoxUser"}
              tDefault={"User (or use keyfile)"}
              tKey={"vestigingen.form.apiaccounts.label.blackBoxUser"}
            />
            <FormTextTC
              name={"apiaccounts__blackBoxPass"}
              tDefault={"Password (or use keyfile)"}
              tKey={"vestigingen.form.apiaccounts.label.blackBoxPass"}
            />
            <FormTextTC
              name={"apiaccounts__blackBoxTerminalID"}
              tDefault={"Terminal ID"}
              tKey={"vestigingen.form.apiaccounts.label.blackBoxTerminalID"}
            />
            <FormTextTC
              name={"apiaccounts__blackBoxTerminalName"}
              tDefault={"Terminal name"}
              tKey={"vestigingen.form.apiaccounts.label.blackBoxTerminalName"}
            />
            <FormTextTC
              name={"apiaccounts__blackBoxOperatorID"}
              tDefault={"Operator ID"}
              tKey={"vestigingen.form.apiaccounts.label.blackBoxOperatorID"}
            />
            <FormTextTC
              name={"apiaccounts__blackBoxOperatorName"}
              tDefault={"Operator name"}
              tKey={"vestigingen.form.apiaccounts.label.blackBoxOperatorName"}
            />
            {blackBoxKeyFileValue && blackBoxKeyPassphraseValue ? (
              <>
                <FormTextTC
                  name={"apiaccounts__blackBoxKeyFile"}
                  tDefault={"Key file"}
                  tKey={"vestigingen.form.apiaccounts.label.blackBoxKeyFile"}
                />
                <FormTextTC
                  name={"apiaccounts__blackBoxKeyPassphrase"}
                  tDefault={"Key passphrase"}
                  tKey={"vestigingen.form.apiaccounts.label.blackBoxKeyPassphrase"}
                />
              </>
            ) : (
              <GridLegacy container spacing={1}>
                <GridLegacy item xs={4} />
                <GridLegacy alignContent={"center"} item xs={8}>
                  <Button color={"success"} onClick={setupFDMAuth}>
                    <TranslationWrapper
                      tDefault={"Get key and passphrase from FDM"}
                      tKey={"vestigingen.form.fdm.oauth"}
                    />
                  </Button>
                </GridLegacy>
              </GridLegacy>
            )}
            <FormControlledInputTC
              name={"apiaccounts__vatRateA"}
              suffix={"%"}
              tDefault={"VAT Rate A"}
              tKey={"vestigingen.form.apiaccounts.label.vatRateA"}
              type={"number"}
            />
            <FormControlledInputTC
              name={"apiaccounts__vatRateB"}
              suffix={"%"}
              tDefault={"VAT Rate B"}
              tKey={"vestigingen.form.apiaccounts.label.vatRateB"}
              type={"number"}
            />
            <FormControlledInputTC
              name={"apiaccounts__vatRateC"}
              suffix={"%"}
              tDefault={"VAT Rate C"}
              tKey={"vestigingen.form.apiaccounts.label.vatRateC"}
              type={"number"}
            />
            <FormControlledInputTC
              name={"apiaccounts__vatRateD"}
              suffix={"%"}
              tDefault={"VAT Rate D"}
              tKey={"vestigingen.form.apiaccounts.label.vatRateD"}
              type={"number"}
            />
          </GridLegacy>
        </CardBody>
      </Card>
    </div>
  );
}

export default BlackBox;
